module.exports = __webpack_public_path__ + "static/media/arrow-down.772a5382.png";